
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.47 19.53a.75.75 0 101.06-1.06l-1.06 1.06zm-4.94-7.06a.75.75 0 10-1.06 1.06l1.06-1.06zM11 8.75a.75.75 0 000-1.5v1.5zm-6-1.5a.75.75 0 000 1.5v-1.5zm9.25.75A6.25 6.25 0 018 14.25v1.5A7.75 7.75 0 0015.75 8h-1.5zM8 14.25A6.25 6.25 0 011.75 8H.25A7.75 7.75 0 008 15.75v-1.5zM1.75 8A6.25 6.25 0 018 1.75V.25A7.75 7.75 0 00.25 8h1.5zM8 1.75A6.25 6.25 0 0114.25 8h1.5A7.75 7.75 0 008 .25v1.5zm11.53 16.72l-6-6-1.06 1.06 6 6 1.06-1.06zM11 7.25H5v1.5h6v-1.5z"}})])
          )
        }
      }
    